<template>
    <widget-wrapper :loader="api" :title="title" :draggable="false" class="js_year_graph">
        <graph-container :datasets="lines">
            <template slot-scope="scope">
                <year-graph :lines="scope.datasets" :height="200"
                            :label-xaxis="labels.xAxis" :label-yaxis="labels.yAxis"/>
            </template>
        </graph-container>
        <year-table :rows="rows"/>
    </widget-wrapper>
</template>
<script>
    import {Component, Prop} from 'vue-property-decorator';
    import DashboardWidget from '../DashboardWidget';
    import WidgetData from '../WidgetDataDecorator';
    import WidgetWrapper from '../WidgetWrapper';
    import GraphContainer from '../../graphs/GraphContainer';
    import YearGraph from './YearGraph';
    import YearTable from './YearTable';
    import _ from 'lodash';

    @Component({
        components: {
            WidgetWrapper,
            GraphContainer,
            YearGraph,
            YearTable,
        },
    })
    export default class YearGraphWidget extends DashboardWidget {
        api = {
            endpoint: 'dashboard/api/sales/monthly_revenue',
        };
        @Prop({
            type: Object,
            require: true,
            default: () => ({
                'id': 7,
                'code': 'BE',
                'number': null,
                'name': 'Belgie',
                'lat': '50.819818',
                'lng': '4.334106',
                'seo_url': 'belgie',
                'created': '05-03-2008 07:58',
                'created_by': 2,
                'modified': '',
                'modified_by': null,
            })
        })
        country;
        @WidgetData(() => _.times(4, i => ({year: 2018 - i, value: _.random(0, 1000)})))
        rows;

        @WidgetData(() => _.times(2, i => (
            {
                label: '' + (2018 - i),
                data: _.times(12, () => _.random(0, 500)),
                hidden: false,
            })))
        lines;

        get title() {
            return this.$t('widgets.year_graph.title', {country: this.$t('countries.' + this.country.code)});
        }

        get labels() {
            return {
                xAxis: this.$t('widgets.year_graph.label_xaxis'),
                yAxis: this.$t('widgets.year_graph.label_yaxis'),
            };
        }

        mounted() {
            this.requestData();
        }

        get requestParams() {
            return {
                country_id: this.country.id,
            };
        }

        onQueryData(response) {
            if (!response) {
                this.rows = [];
                this.labels = [];
                return;
            }
            this.rows = response.data.table.reverse();
            this.lines = response.data.graph.reverse().map((line, index) => ({
                ...line,
                hidden: (index >= 2), // By default disable datasets older than the last 2 years
            }));
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/widgets/year-graph/YearGraphWidget.vue